import type { DocumentVersionStatus } from '@up2d8/contracts';

/**
 * Alleen een concept kan gepubliceerd worden.
 *
 * Een vervangen versie opnieuw publiceren weigert de server bewust (documents-README, "Statussen"):
 * bestaand bewijs zou dan verwijzen naar een versie die intussen iets anders betekent. Hier stond
 * `status !== 'published'`, waardoor de knop ook bij een vervangen versie stond en een klik op
 * "Er ging iets mis" uitkwam (testrapport 28 okt., #9).
 */
export function canPublishVersion(status: DocumentVersionStatus): boolean {
  return status === 'draft';
}
